import { type FC } from "react";

import { SectionType } from "components/server-types";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { Menu, MenuLinkItem } from "mds/components/Menu";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { BookSectionLinkedIcon, ChevronDownIcon } from "mds/icons";
import { sectionHomeUrl } from "utils/urls";

export const LinkedSectionsMenu: FC<{ linkedSections: SectionType[] }> = ({ linkedSections }) => {
  const label = t("section_view.template_linked_sections", { count: linkedSections.length });
  const iconText = (
    <IconText
      className="text-xs font-medium text-black-tint-40"
      iconEnd={linkedSections.length > 0 ? <ChevronDownIcon /> : undefined}
      iconStart={<BookSectionLinkedIcon />}
      text={label}
    />
  );

  if (linkedSections.length === 0) {
    return iconText;
  }

  return (
    <Menu
      align="start"
      menuButton={
        <SquareButton kind="ghost" size="xs">
          {iconText}
        </SquareButton>
      }
    >
      {linkedSections.map((linkedSection) => (
        <MenuLinkItem key={linkedSection.id} to={sectionHomeUrl(linkedSection.id)}>
          {linkedSection.title}
        </MenuLinkItem>
      ))}
    </Menu>
  );
};
